import _typeof from "@babel/runtime/helpers/typeof";

/**
 * Convert partial URLs into full ones
 * @param {string} href Full/partial (relative or protocol-relative) URL
 * @note This functions takes in a string and returns the full URL, as processed by a browser when supplied to a link's `href` property.
 * It is mainly used to convert partial URLs into full URLs for use in analytics tracking.
 *
 * Relative URLs will be prepended with the window's current hostname and protocol.
 * Protocol-relative URLs will be prepended with the window's current protocol.
 * If a window/window.location isn't available, it will return the URL unchanged.
 */
export var getFullUrl = function getFullUrl(href) {
  var _window, _window$location, _window2, _window2$location;

  // Return the URL unchanged if the window/location is not available
  if (typeof href !== 'string' || (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object' || !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.protocol) || !((_window2 = window) !== null && _window2 !== void 0 && (_window2$location = _window2.location) !== null && _window2$location !== void 0 && _window2$location.hostname)) {
    return href;
  } // Prepend the current protocol if it is missing


  if (href.indexOf('//') === 0) {
    return "".concat(window.location.protocol).concat(href);
  } // Prepend the current hostname if it is missing


  if (href.indexOf('/') === 0) {
    return "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(href);
  }

  return href;
};